import { m } from 'motion/react';
import { Dumbbell, Baby, Car, Shield, Wifi, Leaf } from 'lucide-react';

export function Amenities() {
  const amenities = [
    {
      icon: Dumbbell,
      title: 'Fitness Center',
      description: 'Modern ekipmanlarla donatılmış profesyonel spor salonu',
    },
    {
      icon: Baby,
      title: 'Çocuk Oyun Alanı',
      description: 'Güvenli ve eğlenceli oyun parkları',
    },
    {
      icon: Car,
      title: 'Kapalı Otopark',
      description: 'Güvenli ve geniş kapalı otopark alanları',
    },
    {
      icon: Shield,
      title: '7/24 Güvenlik',
      description: 'Kamera ve güvenlik sistemi ile tam güvenlik',
    },
    {
      icon: Wifi,
      title: 'Fiber İnternet',
      description: 'Yüksek hızlı fiber internet altyapısı',
    },
    {
      icon: Leaf,
      title: 'Yeşil Alanlar',
      description: 'Geniş peyzaj ve yürüyüş parkurları',
    },
  ];

  return (
    <section id="amenities" className="py-24 bg-white dark:bg-slate-950">
      <div className="container mx-auto px-4 lg:px-8">
        <m.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="inline-block px-4 py-2 bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300 rounded-full text-sm tracking-wider mb-4">
            SOSYAL DONATILAR
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 dark:text-slate-100 mb-6">
            Ayrıcalıklı{' '}
            <span className="text-stone-700 dark:text-stone-300">
              Yaşam Alanları
            </span>
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
            Rain Nova'da her anınız özel. Zengin sosyal donatılarımızla hayatınızın her
            alanında konfor ve lüksü yaşayın.
          </p>
        </m.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {amenities.map((amenity, index) => (
            <m.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.05 }}
              whileHover={{ y: -8, transition: { duration: 0.2 } }}
              className="bg-white dark:bg-slate-950 border border-gray-200 dark:border-slate-800 rounded-xl p-6 hover:shadow-2xl hover:border-slate-300 dark:hover:border-slate-700 transition-all duration-300 cursor-pointer group"
            >
              <div className="flex flex-col items-center text-center">
                <div className="w-16 h-16 rounded-full bg-slate-100 dark:bg-slate-800 flex items-center justify-center mb-4 group-hover:bg-slate-900 dark:group-hover:bg-white transition-all duration-300 group-hover:scale-110">
                  <amenity.icon
                    size={28}
                    className="text-slate-900 dark:text-white group-hover:text-white dark:group-hover:text-slate-900 transition-colors duration-300"
                  />
                </div>
                <h3 className="text-lg font-semibold text-slate-900 dark:text-slate-100 mb-2 group-hover:text-slate-900 dark:hover:text-white transition-colors">
                  {amenity.title}
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-400">{amenity.description}</p>
              </div>
            </m.div>
          ))}
        </div>
      </div>
    </section>
  );
}
